/**
 * Специальная панель для разработки и тестирования различных компонент
 */
import React from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

import OWLGraph from '../components/graph/OWLGraph';
import SPARQLGraph from '../components/graph/SPARQLGraph';
let mapStateToProps = null;
let mapDispatchToProps = null;


// Для графа SKOS
import skosGraphContent from '../demo/skos.owl.content.sparql.response.json'; //skos.owl.content.sparql.response.json';
import skosGraphSettings from '../demo/skos.graph.settings.json'; //skos.graph.settings.json';
import skosPropsGraphSettings from '../demo/skos.props.settings.json';

// Для графа SKOS
import dctermsGraphContent from '../demo/dcterms.content.sparql.response.json'; 
import dctermsGraphSettings from '../demo/dcterms.graph.settings.json'; 

//Для графа онтологии EuroVoc
import eurovocOwlGraphContent from '../demo/eurovoc.owl.content.sparql.response.json'; 
import eurovocOwlGraphSettings from '../demo/eurovoc.owl.graph.settings.json'; 

//Для REST API FLOWABLE
import FlowableDevelopment from '../flowable/Development';

//Для ЕМД
import { factory } from '../components/adms/Providers'
import EMDCard from '../views/emd/EMDCard';

const emdMapStateToProps = (state, props) => {
  //console.log("EMDCardView containers", props);
  const { vasset, emd, vviews} = state;
  return ({
    lang: "ru",
    isSignedIn: true,
    content: emd.content,
  })
};

const emdMapDispatchToProps = dispatch => ({
  onReload (adms, emd, catalog, IRI){
    return Promise.all([dispatch(adms.loadSelected(IRI)), dispatch(emd.loadContent(IRI))]);
  },
  //Событие, которое загружает содержимое
  onContentSelected (actions, catalog, iri){
    if (actions)
      dispatch(actions.loadContent(NodId, repository));
  },
  onReloadViews (actions, IRI){
    return dispatch(actions.loadViews(IRI));
  },
});

mapStateToProps = emdMapStateToProps;
mapDispatchToProps = emdMapDispatchToProps;


/** Представление обеспечивае загрузку данных с использованием SPARQL запроса по 
 * и отборажение его с использованием SPARQLGraph */
class DevelopmentPanel extends React.Component {
  
  componentDidMount() {
    this.loadcontent()
  }

  loadcontent() {
  }

  render(){
    console.log(this);
		return (
      <FlowableDevelopment />
    )
  }
}
//<EMDCard IRI="http://csi.semanticpro.org/ontologies/2021/09/adms#EMD" {...this.props} />
//<FlowableDevelopment />
//<OWLGraph content={dctermsGraphContent} settings={dctermsGraphSettings}/>
//<SPARQLGraph content={eurovocOwlGraphContent} settings={eurovocOwlGraphSettings}/>
//<SPARQLGraph content={skosGraphContent} settings={skosPropsGraphSettings}/>
//<OWLGraph content={eurovocOwlGraphContent} settings={eurovocOwlGraphSettings}/>

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DevelopmentPanel));
